<template>
  <div class="row" id="visiteCantina">
<!--    <event-modal img="../../static/image/pop-up-quvestra.jpg" :title="'Sospensione Attività'"></event-modal>-->
    <!--    <div class="col-xl-4 col-lg-12 col-sm-12 col-md-12 image"-->
<!--         v-bind:style="{ backgroundImage: 'url(' + image1 + ')', height: (myHeight) + 'px'}">-->
<!--      <div class="visita">-->
<!--        <router-link :to="{name: 'visiteregistrazione', params: {id: 1, language: $i18n.locale}}">-->
<!--          <div class="quad">-->
<!--            <div class="logo"><img class="imag" v-bind:src=logo1></div>-->
<!--            <div>Wine Tour "Basic"</div>-->
<!--            <div class="scopri">-->
<!--              <div>Scopri</div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </router-link>-->
<!--      </div>-->
<!--    </div>-->
    <div class="col-xl-12 col-lg-12 col-sm-12 col-md-12 image"
         v-bind:style="{ backgroundImage: 'url(' + image4 + ')', height: (myHeight) + 'px'}">
      <div class="visita">
        <router-link :to="{name: 'visiteregistrazione', params: {id: 24, language: $i18n.locale}}">
          <div class="quad">
            <div class="logo"><img class="imag" v-bind:src=logo4></div>
            <div>{{$t("base")}}</div>
            <div class="scopri">
              <div>{{$t("scopri")}}</div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
<!--    <div class="col-xl-6 col-lg-12 col-sm-12 col-md-12 image"-->
<!--         v-bind:style="{ backgroundImage: 'url(' + image3 + ')', height: (myHeight) + 'px'}">-->
<!--      <div class="visita">-->
<!--        <router-link :to="{name: 'visiteregistrazione', params: {id: 3, language: $i18n.locale}}">-->
<!--          <div class="quad">-->
<!--            <div class="logo"><img class="imag" v-bind:src=logo3></div>-->
<!--            <div>{{$t("botte")}}</div>-->
<!--            <div class="scopri">-->
<!--              <div>{{$t("scopri")}}</div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </router-link>-->
<!--      </div>-->
<!--    </div>-->
    <!--<div class="col-xl-6 col-lg-12 col-sm-12 col-md-12 image"
         v-bind:style="{ backgroundImage: 'url(' + image2 + ')', height: (myHeight-50) + 'px'}">
      <div class="visita">
        <router-link :to="{name: 'visiteregistrazione', params: {id: 2, language: $i18n.locale}}">
          <div class="quad">
            <div class="logo"><img class="imag" v-bind:src=logo2></div>
            <div>Wine Tour "Gourmet"</div>
            <div class="scopri">
              <div>Scopri</div>
            </div>
          </div>
        </router-link>
      </div>
    </div>-->
  </div>
</template>

<script>
  import ModalCovid from "./global/EventModal";
  import EventModal from "./global/EventModal";
  export default {
    name: 'visiteCantina',
    components: {EventModal, ModalCovid},
    data() {
      return {
        image1: 'static/image/visiteinCantina/attivitaVisiteCantina2.jpg',
        image2: 'static/image/visiteinCantina/cantinaWineTourTop2.jpg',
        image3: 'static/image/visiteinCantina/cantinaWineTourBotte2.jpg',
        image4: 'static/image/visiteinCantina/cantinaWineTourPlus.jpg',
        logo1: 'static/image/visiteinCantina/grappolo.png',
        logo2: 'static/image/visiteinCantina/plate.png',
        logo3: 'static/image/visiteinCantina/botte.png',
        logo4: 'static/image/visiteinCantina/cavatappi.png',
        myHeight: window.innerHeight,
        scrittaCarousel: 800
      }
    },
    i18n: {
      fallbackLocale: 'it', // default lang,
      messages: {
        it: {
          plus: 'Degustazione "Plus"',
          base: 'Degustazione "Base"',
          botte:'Degustazione "in botte"',
          scopri:'Scopri',
          titolo: {
            tasting: 'Degustazione',
            cask: '"in botte"'
          }
        },
        en: {
          plus:'Wine Tasting "Plus"',
          base: 'Wine Tasting "Base"',
          botte:'Barrel Tasting',
          scopri: 'Discover',
          titolo: {
            tasting: 'Tasting',
            cask: '"in cask"'
          }
        }
      }
    },
    updated: function () {
      window.addEventListener('resize', this.getPageHeight)
    },
    mounted: function () {
      window.addEventListener('resize', this.getPageHeight)
      this.getPageHeight()
      window.scroll(0, 0)
    },
    methods: {
      getPageHeight: function (event) {
        this.myHeight = window.innerHeight
        this.scrittaCarousel = this.myHeight - 150
      }
    }
  }
</script>

<style lang="less">
  @import "../assets/less/variabili.less";
  @import "../assets/less/font.less";

  a {
    color: #FFFFFF;
  }

  a:hover {
    color: #FFFFFF;
    text-decoration: none;
    cursor: pointer;
  }

  #visiteCantina {
    margin-right: 0px;
    margin-left: 0px;
    //opacity: 0.1%;
    z-index: 1;
    .image {
      background-size: cover;
      background-position-x: center;
      .visita {
        display: flex;
        height: 100%;
        align-items: center;
        justify-content: center;
        text-align: center;
        .set-font-title(@size: 30px);
        .quad {
          width: 300px;
          height: 300px;
          padding: 20px;
          padding-top: 70px;
          margin: auto;
          background-color: rgba(0, 0, 0, 0.7);
          border: 1px solid gray;
          .logo {
            .imag {
              width: 30px;
            }
          }
          .scopri{
            background-color: black;
            border: 1px solid white;
            margin: auto;
            margin-top: 50px;
            width: 90%;
            .set-font(@size: 20px);
          }
        }
      }
    }
    /*.logo:before, .logo:after {*/
      /*background-color: white;*/
      /*content: "";*/
      /*display: inline-block;*/
      /*height: 1px;*/
      /*position: relative;*/
      /*vertical-align: middle;*/
      /*width: 40%;*/
    /*}*/
    /*.logo:before {*/
      /*right: 0.2em;*/
      /*margin-left: -50%;*/
    /*}*/

    /*.logo:after {*/
      /*left: 0.2em;*/
      /*margin-right: -50%;*/
    /*}*/

    .quad:hover {
      transform: scale(1.1);
    }

    .quad {
      transition: all .2s ease-in-out;
    }
  }

  @media (max-width: 767px) {
    #visiteCantina {
      z-index: 1;
      .image {
        padding-top: 1px;
        .visita {
          width: 100%;
          height: 40%;
          padding-top: 5px;
          margin-top: 60%;
          .quad {
            margin: auto;
            width: 260px;
            height: 260px;
            padding: 20px;
            padding-top: 30px;
            .logo {
            }
          }
        }
      }
    }

    .logo:before, .logo:after {
      width: 35%;
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    #visiteCantina {
      z-index: 1;
      .image {
        .visita {
          padding-top: 0px;
          .quad {
            margin: auto;
            .logo {
            }
          }
        }
      }
    }

    .logo:before, .logo:after {
    }
  }

  @media (min-width: 1025px) and (max-width: 1366px) {
    #visiteCantina {
      z-index: 1;
      .image {
        .visita {
          padding-top: 0px;
          .quad {
            margin: auto;
            .logo {
            }
          }
        }
      }
    }

    .logo:before, .logo:after {
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/VisiteCantina.vue